import { BehaviorSubject } from "rxjs";

const isSmallDevice$: BehaviorSubject<boolean> = new BehaviorSubject(
  typeof window !== "undefined" ? window.innerWidth <= 768 : false,
);

export { isSmallDevice$ };
